import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Cosmic Billboard Network',
		description:
			'Place advertising billboards on passing asteroids. Great visibility, questionable ROI.'
	},
	{
		name: 'Nebula Neon Signs',
		description:
			'Transform entire nebulae into glowing advertisements. Visible from only 1,000 light years away!'
	},
	{
		name: 'Quantum Ad Placement',
		description:
			'Your ads exist in all possible locations until someone tries to ignore them.'
	},
	{
		name: 'Supernova Sponsorships',
		description:
			'Brand dying stars before they explode. The ultimate in flash advertising!'
	},
	{
		name: 'Time-Dilated Marketing',
		description:
			"Place ads near black holes where they last for centuries from Earth's perspective."
	},
	{
		name: 'Multiverse Marketing Campaign',
		description:
			"Advertise across infinite parallel universes. Now that's what I call market reach!"
	},
	{
		name: 'Void Advertising Network',
		description:
			'Broadcast ads into the void. Zero viewers, infinite potential!'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Interstellar Advertising'],
	departments[DepartmentIds['Interstellar Advertising']].basePrice * 3,
	UpgradeIds.InaExponent1
)

export default array
